import PropTypes from 'prop-types';
import styled from 'styled-components';

function getOpacityFromProps(hoverState) {
  return ({ disabled }) => {
    if (disabled) return 0;

    if (hoverState) return 0.2;

    return 0;
  };
}

const Highlight = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: white;
  opacity: ${getOpacityFromProps(false)};
  &:hover {
    opacity: ${getOpacityFromProps(true)};
  }
`;

Highlight.propTypes = {
  disabled: PropTypes.bool,
};

Highlight.defaultProps = {
  disabled: false,
};

export default Highlight;
